// extracted by mini-css-extract-plugin
export default {"container":"mPs6KhSS03NsgctLqo_X","header":"_E1EuMKqLP2AL3rY3303","title":"FiO7LOjvTb6CKn22zAgl","wasDiceUnfair":"PjRjaQ2MxsIokJ64b65N","grayBar":"XxvGuxW1DcWUd6SatqOW"};